import React, { useEffect, useState } from "react";
import Modal from "../../../../shared/Modal";
import Button from "../../../../shared/Button";
import useForm from "../../../../hooks/useForm";
import { useAuth } from "../../../../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  fetchOrganizations,
  selectOrganizationsOptions,
} from "../../../../redux/reducers/organizations/organizationsSlice";
import { FORM_OPTIONS } from "../../../Drivers/driver.table.config";
import DriverCreateForm from "../../../Drivers/DriverCreateModal/DriverCreateForm";
import Toggle from "../../../../shared/Toggle";
import { useCreateDriverMutation } from "../../../../redux/services/drivers/driversApi";
import { buildDriverMetaPayload } from "../../../../utils/driver-profile.utils";

const DriverForm = ({ visible, setVisible, hideOrg, children, ...props }) => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const [addExisting, setAddExisting] = useState(true);

  const [createDriver, { isLoading: isCreating }] = useCreateDriverMutation();

  const { form, clearForm, updateForm, errors, setFormInit } =
    useForm(FORM_OPTIONS);

  const [driverOrg, setDriverOrg] = useState(false);

  const orgs = useSelector((state) => state.organizations);
  const orgOptions = useSelector(selectOrganizationsOptions);

  useEffect(() => {
    if (driverOrg && orgs.status === "idle") {
      dispatch(fetchOrganizations({ parent: user.parentCompany }));
    }
  }, [driverOrg, orgs.status]);

  function handleClose(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    setVisible(false);
    clearForm();
    setDriverOrg(false);
  }

  async function handleSubmit() {
    if (props.toggle && addExisting) {
      setVisible(false);
      setDriverOrg(false);
      return props.onSubmit && props.onSubmit(form, true);
    }

    try {
      const res = await createDriver({
        ...form,
        type: "driver",
        parentCompany: user.parentCompany,
        meta: buildDriverMetaPayload(form),
      }).unwrap();

      if (res.status === "success") {
        props.onSubmit && props.onSubmit(res);
        setVisible(false);
        clearForm();
        setDriverOrg(false);
        toast("Successfully created a new driver", {
          toastId: "newDriverAdded",
          type: "success",
        });
      }
    } catch (error) {
      toast(error?.data?.message || "Error creating driver", {
        toastId: "driverCreateError",
        type: "error",
      });
    }
  }

  const modalFooter = (
    <div>
      <Button
        className="mr-3"
        htmlType="button"
        onClick={handleClose}
        type="alternative"
      >
        Cancel
      </Button>
      <Button
        disabled={isCreating}
        loading={isCreating}
        htmlType="button"
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </div>
  );

  const modalProps = {
    form,
    updateForm,
    clearForm,
    setDriverOrg,
    errors,
    driverOrg,
    orgs: orgs.data,
    orgOptions,
    hideOrg,
    user,
  };

  const modalContent = (
    <div className="space-y-3">
      {props.toggle && (
        <Toggle
          label="Create"
          checked={!addExisting}
          onChange={() => setAddExisting(!addExisting)}
        />
      )}
      {addExisting ? props.content : <DriverCreateForm {...modalProps} />}
    </div>
  );

  return (
    <>
      {children &&
        React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              form,
              clearForm,
              updateForm,
              setFormInit,
            });
          }
          return child;
        })}
      <Modal
        visible={visible}
        setVisible={setVisible}
        onClose={handleClose}
        title="Add Driver"
        footer={modalFooter}
        content={modalContent}
        size="xl"
        footerPosition="right"
      />
    </>
  );
};

export default DriverForm;
